import { BaseEntity } from 'yt-ng-framework';

export class KomitentVozilo extends BaseEntity {
    constructor(){
        super();
    }
    KomitentID: number = null;
    RgBr: string = null;

    Deserialize(input: any){
        // super.Deserialize(input);
        this.ID = input.ID;
        this.KomitentID = input.KomitentID;
        this.RgBr = input.RgBr;
        return this;
    }

    Serialize(input: KomitentVozilo){
        return input;
    }
}